<template>
  <div class="doorpostscene">
    <div class="header">
      <div class="title">业务应用场景</div>
      <div class="border"></div>
    </div>

    <div class="body">
      <div class="list">
        <div class="item" v-for="item in list" :key="item.id">
          <img :src="item.logo" alt="" />
          <div class="title">{{ item.title }}</div>
          <div class="text">{{ item.text }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import doorpostscene1 from "../../../../assets/programme/doorpostscene1.png";
import doorpostscene2 from "../../../../assets/programme/doorpostscene2.png";
import doorpostscene3 from "../../../../assets/programme/doorpostscene3.png";
import doorpostscene4 from "../../../../assets/programme/doorpostscene4.png";

export default {
  setup() {
    return reactive({
      list: [
        {
          id: 1,
          logo: doorpostscene1,
          title: "在线、自助访客预约，便捷通行",
          text: "业主APP授权二维码，访客通过扫码出入，全程线上操作，方便快捷",
        },
        {
          id: 2,
          logo: doorpostscene2,
          title: "全面的电子化登记过程，人员管控模式升级",
          text: "用户申请、线上呼叫、远程开门等全程电子化登记，人员管控更规范",
        },
        {
          id: 3,
          logo: doorpostscene3,
          title: "拜访过程免登记，无干扰体验好",
          text: "访客拜访过程业主直接提供二维码或访客远程呼叫业主，免除线下登记，体验好",
        },
        {
          id: 4,
          logo: doorpostscene4,
          title: "拜访记录归档，访客滞留智能提醒物业关注",
          text: "拜访记录全程电子化登记存档，访客到访信息随时发送业主，免除陌生人滞留安全隐患",
        },
      ],
    });
  },
};
</script>

<style scoped>
.doorpostscene {
  width: 1180px;
  margin: 80px auto 0;
}
.header .title {
  font-size: 30px;
  text-align: center;
}
.header .border {
  width: 40px;
  height: 5px;
  background: #248efb;
  margin: 20px auto 0;
}

.body {
  margin-top: 40px;
}
.body .list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.body .list .item {
  width: 570px;
  text-align: center;
  border: 1px solid #d5e3fa;
  margin-bottom: 40px;
  overflow: hidden;
}
.body .list .item:hover img {
  animation: experienceHover 1s;
}
@keyframes experienceHover {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.2);
  }
}
.body .list .item img {
  width: 570px;
}
.body .list .item .title {
  font-size: 24px;
  margin-top: 40px;
  color: #248efb;
}
.body .list .item .text {
  width: 480px;
  margin: 20px auto 40px;
  font-size: 14px;
  color: #495a6c;
}
</style>
